import { createContext, useContext, useState } from "react";
import { logUserReportedError } from "../firebase/firestore";
import { Notify } from "../../utils/functions";


const LogErrorContext = createContext();

export function useLogError() {
    const context = useContext(LogErrorContext);
    if (!context) {
        throw new Error('useLogError must be used within an LogErrorProvider');
    }
    return context;
}

export function LogErrorProvider({ children }) {
    const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
    const [errorToReport, setErrorToReport] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const showReportDialog = (errorData) => {
        setErrorToReport(errorData);
        setIsReportDialogOpen(true);
    };

    const closeReportDialog = () => {
        setIsReportDialogOpen(false);
        setErrorToReport(null);
    };

    const reportError = async (errorDetails) => {
        setIsSubmitting(true);
        try {
            // Add error to Firestore
            await logUserReportedError(errorDetails, errorDetails.additionalInfo || 'User reported error');

            Notify('Error reported successfully. Thank you for helping us improve!', 'success');
            closeReportDialog();
        } catch (error) {
            console.error('Error reporting failed:', error);
            Notify('Failed to report error. Please try again.', 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    const value = {
        isReportDialogOpen,
        errorToReport,
        isSubmitting,
        showReportDialog,
        closeReportDialog,
        reportError
    };

    return (
        <LogErrorContext.Provider value={value}>
            {children}
        </LogErrorContext.Provider>
    );
}